import { createMapColorThemeContext } from "@app/shared/map-appearance/MapColorThemeContext";
import {
  PROVIDER_LANDSCAPE_COLOR_THEME_AMETHYST,
  PROVIDER_LANDSCAPE_COLOR_SLOT_DEFINITIONS,
  PROVIDER_LANDSCAPE_PRESET_THEMES,
} from "@app/overviews/market-expansion-dashboard/components/provider-landscape-map/ProviderLandscapeColorThemeConstants";

const ProviderLandscapeColorTheme = createMapColorThemeContext({
  defaultTheme: PROVIDER_LANDSCAPE_COLOR_THEME_AMETHYST,
  localStorageKeySuffix: "market-expansion-provider-landscape-color-theme",
  presetThemes: PROVIDER_LANDSCAPE_PRESET_THEMES,
  slotDefinitions: PROVIDER_LANDSCAPE_COLOR_SLOT_DEFINITIONS,
})

export { ProviderLandscapeColorTheme };
